import React from 'react';
import { ParsedTransaction } from '../../../../../typings/transaction';

const TransactionContext: React.Context<ParsedTransaction | null> = React.createContext(null);
export const TransactionProvider = TransactionContext.Provider;
export const TransactionConsumer = TransactionContext.Consumer;
export default TransactionContext;
